import { useLanguage } from '../utils/LanguageContext';
import { Language } from '../shared/constants/userConstants';
import { Link } from 'react-router-dom';

const { ENGLISH, SPANISH } = Language;

const LanguageToggle = () => {
  const { langForEnum, currentLanguage, setCurrentLanguage } = useLanguage();
  const targetLanguage = currentLanguage === 'en' ? SPANISH : ENGLISH;
  return <Link onClick={() => setCurrentLanguage(targetLanguage)}>{langForEnum(Language, targetLanguage)}</Link>;
};

export default LanguageToggle;
